function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Practice-Management-v0",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Main-dashboard",
  transform: "translate(-36.000000, -197.000000)"
}, React.createElement("g", {
  id: "main-nav",
  transform: "translate(-6.000000, 0.000000)"
}, React.createElement("g", {
  id: "baseline-bar_chart-24px",
  transform: "translate(36.000000, 192.000000)"
}, React.createElement("path", {
  d: "M6.66666667,9.2 L10.6666667,9.2 L10.6666667,19 L6.66666667,19 L6.66666667,9.2 Z M14.1333333,5 L17.8666667,5 L17.8666667,19 L14.1333333,19 L14.1333333,5 Z M21.6,13 L25.3333333,13 L25.3333333,19 L21.6,19 L21.6,13 Z",
  id: "Shape",
  fill: "#308BFD",
  fillRule: "nonzero"
}), React.createElement("polygon", {
  id: "Path",
  points: "0 0 32 0 32 24 0 24"
})))));

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "14px",
    viewBox: "0 0 20 14",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard.fc536bb0.svg";
export { ForwardRef as ReactComponent };